var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasError)?_c('v-alert',{staticClass:"error-alert",class:{'error-alert--dismissible': _vm.dismissible},attrs:{"type":"error","value":_vm.visible,"dense":"","dismissible":_vm.dismissible},on:{"click":_vm.onCloseIconClick}},[_vm._v(_vm._s(_vm.message))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }